import React from "react"
import styled from "styled-components"
import { useButtonFillColor } from "../../hooks/useButtonFillColor"

type ButtonProps = {
  style?: React.CSSProperties
  location: string
  onClick?: () => void
}

const OverviewButton: React.FC<ButtonProps> = ({
  onClick,
  location,
  style,
}) => {
  const { fillColor } = useButtonFillColor(location)

  return (
    <Button
      onClick={onClick}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <svg
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30.2998 59C37.3998 59 43.8998 56.5 48.9998 52.3L54.4998 57.8C54.8998 58.2 55.3998 58.4 55.8998 58.4C56.3998 58.4 56.8998 58.2 57.2998 57.8C58.0998 57 58.0998 55.8 57.2998 55L51.8998 49.6C56.7998 44.3 59.7998 37.3 59.7998 29.5C59.7998 13.2 46.5998 0 30.2998 0C13.9998 0 0.799805 13.2 0.799805 29.5C0.799805 45.8 14.0998 59 30.2998 59ZM30.2998 4C44.3998 4 55.7998 15.4 55.7998 29.5C55.7998 43.6 44.3998 55 30.2998 55C16.1998 55 4.7998 43.6 4.7998 29.5C4.7998 15.4 16.2998 4 30.2998 4Z"
          fill={fillColor}
        />
        <path
          d="M58.6 61.9004L59.8 63.1004C60.2 63.5004 60.7 63.7004 61.2 63.7004C61.7 63.7004 62.2 63.5004 62.6 63.1004C63.4 62.3004 63.4 61.1004 62.6 60.3004L61.4 59.0004C60.6 58.2004 59.4 58.2004 58.6 59.0004C57.8 59.8004 57.8 61.1004 58.6 61.9004Z"
          fill={fillColor}
        />
        <path
          d="M17.7998 41C18.8998 41 19.7998 40.1 19.7998 39V31C19.7998 29.9 18.8998 29 17.7998 29C16.6998 29 15.7998 29.9 15.7998 31V39C15.7998 40.1 16.6998 41 17.7998 41Z"
          fill={fillColor}
        />
        <path
          d="M28.7998 28.1C29.8998 28.1 30.7998 27.2 30.7998 26.1V25C30.7998 23.9 29.8998 23 28.7998 23C27.6998 23 26.7998 23.9 26.7998 25V26.1C26.7998 27.2 27.6998 28.1 28.7998 28.1Z"
          fill={fillColor}
        />
        <path
          d="M28.7998 40.9992C29.8998 40.9992 30.7998 40.0992 30.7998 38.9992V31.6992C30.7998 30.5992 29.8998 29.6992 28.7998 29.6992C27.6998 29.6992 26.7998 30.5992 26.7998 31.6992V38.9992C26.7998 40.0992 27.6998 40.9992 28.7998 40.9992Z"
          fill={fillColor}
        />
        <path
          d="M39.7998 41C40.8998 41 41.7998 40.1 41.7998 39V19C41.7998 17.9 40.8998 17 39.7998 17C38.6998 17 37.7998 17.9 37.7998 19V39C37.7998 40.1 38.6998 41 39.7998 41Z"
          fill={fillColor}
        />
      </svg>
    </Button>
  )
}

export { OverviewButton }

const Button = styled.button`
  padding: 1rem;
  border-radius: 50%;
  height: 4em;
  width: 4em;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;

  &:active {
    background-color: rgba(0, 0, 0, 0.1);
  }

  svg > path {
    transition: fill 0.4s ease-in-out;
  }
`
